__turbopack_context__.v({
  "benefits": "versus-module__EwksFG__benefits",
  "builder": "versus-module__EwksFG__builder",
  "categoryGrid": "versus-module__EwksFG__categoryGrid",
  "categoryIcon": "versus-module__EwksFG__categoryIcon",
  "consoleFloat": "versus-module__EwksFG__consoleFloat",
  "createButton": "versus-module__EwksFG__createButton",
  "createForm": "versus-module__EwksFG__createForm",
  "ctaIcon": "versus-module__EwksFG__ctaIcon",
  "customTime": "versus-module__EwksFG__customTime",
  "divider": "versus-module__EwksFG__divider",
  "error": "versus-module__EwksFG__error",
  "eyebrow": "versus-module__EwksFG__eyebrow",
  "faq": "versus-module__EwksFG__faq",
  "faqContent": "versus-module__EwksFG__faqContent",
  "faqShapeOne": "versus-module__EwksFG__faqShapeOne",
  "faqShapeTwo": "versus-module__EwksFG__faqShapeTwo",
  "faqVisual": "versus-module__EwksFG__faqVisual",
  "field": "versus-module__EwksFG__field",
  "fieldLabel": "versus-module__EwksFG__fieldLabel",
  "gameOptionIcon": "versus-module__EwksFG__gameOptionIcon",
  "gameOptionList": "versus-module__EwksFG__gameOptionList",
  "gameOptionState": "versus-module__EwksFG__gameOptionState",
  "gamePicker": "versus-module__EwksFG__gamePicker",
  "gamePickerAction": "versus-module__EwksFG__gamePickerAction",
  "gamePickerBack": "versus-module__EwksFG__gamePickerBack",
  "gamePickerClose": "versus-module__EwksFG__gamePickerClose",
  "gamePickerHeader": "versus-module__EwksFG__gamePickerHeader",
  "gamePickerPanel": "versus-module__EwksFG__gamePickerPanel",
  "gamePickerSummary": "versus-module__EwksFG__gamePickerSummary",
  "gamePickerSummaryCopy": "versus-module__EwksFG__gamePickerSummaryCopy",
  "gamePickerSummaryIcon": "versus-module__EwksFG__gamePickerSummaryIcon",
  "haloBreathe": "versus-module__EwksFG__haloBreathe",
  "hero": "versus-module__EwksFG__hero",
  "heroCopy": "versus-module__EwksFG__heroCopy",
  "heroHalo": "versus-module__EwksFG__heroHalo",
  "heroVisual": "versus-module__EwksFG__heroVisual",
  "infoPanel": "versus-module__EwksFG__infoPanel",
  "joinRow": "versus-module__EwksFG__joinRow",
  "modeCheck": "versus-module__EwksFG__modeCheck",
  "modeField": "versus-module__EwksFG__modeField",
  "modeGrid": "versus-module__EwksFG__modeGrid",
  "page": "versus-module__EwksFG__page",
  "pickerReveal": "versus-module__EwksFG__pickerReveal",
  "popularPanel": "versus-module__EwksFG__popularPanel",
  "primaryButton": "versus-module__EwksFG__primaryButton",
  "rail": "versus-module__EwksFG__rail",
  "railDivider": "versus-module__EwksFG__railDivider",
  "rangeControl": "versus-module__EwksFG__rangeControl",
  "rangeRow": "versus-module__EwksFG__rangeRow",
  "roomCodeInput": "versus-module__EwksFG__roomCodeInput",
  "roundsField": "versus-module__EwksFG__roundsField",
  "sectionHeading": "versus-module__EwksFG__sectionHeading",
  "selectWrap": "versus-module__EwksFG__selectWrap",
  "settingsGrid": "versus-module__EwksFG__settingsGrid",
  "spin": "versus-module__EwksFG__spin",
  "spinner": "versus-module__EwksFG__spinner",
  "srOnly": "versus-module__EwksFG__srOnly",
  "steps": "versus-module__EwksFG__steps",
  "timeField": "versus-module__EwksFG__timeField",
  "timeOptions": "versus-module__EwksFG__timeOptions",
  "verification": "versus-module__EwksFG__verification",
  "workspace": "versus-module__EwksFG__workspace",
});
